<template>
  <div v-if="tariffed_device_info" class="tariffed_device_info">
    <div class="tariffed_device_info__left">
      <div class="content">
        <div class="row">
          <div class="col-md-3">
            <router-link :to="'/tariff/' + tariffed_device_info.tariff_id" class="link">
              <fg-input
                  v-model="tariffed_device_info.tariff_name"
                  type="text"
                  :label="translate('tariffication.tariff_name')"
                  :placeholder="translate('tariffication.tariff_name')"
                  :readonly="true"
              />
            </router-link>
          </div>
          <div class="col-md-3">
            <router-link :to="'/client/' + tariffed_device_info.client_id" class="link">
              <fg-input
                  v-model="tariffed_device_info.client_name"
                  type="text"
                  :label="translate('tariffication.client_name')"
                  :placeholder="translate('tariffication.client_name')"
                  :readonly="true"
              />
            </router-link>
          </div>

          <div class="col-md-3">
            <fg-input
                v-model="tariffed_device_status"
                type="text"
                :label="translate('tariffication.status')"
                :placeholder="translate('tariffication.status')"
                :readonly="true"
            />
          </div>

          <div class="col-md-3" v-if="tariffed_device_info.ts_tariff_start > 0">
            <fg-input
                v-model="get_ts_tariff_start"
                type="text"
                :label="translate('tariffication.ts_tariff_start')"
                :placeholder="translate('tariffication.ts_tariff_start')"
                :readonly="true"
            />
          </div>
        </div>

        <div class="row">
          <div class="col-md-3" >
            <fg-input
                v-model="tariffed_device_info.client_service_id"
                type="text"
                :label="tariffed_device_info.client_service_name"
                :placeholder="tariffed_device_info.client_service_name"
                :readonly="!read_only"
            />
          </div>
          <div class="col-md-3" >
            <fg-input
                v-model="tariffed_device_info.order_id"
                type="text"
                :label="translate('tariffication.order_number')"
                :placeholder="translate('tariffication.order_number')"
                :readonly="!read_only"
            />
          </div>
          <div class="col-md-3" >
            <WrapDatePicker
                v-model="tariffed_device_info.order_date"
                type="date"
                :range="false"
                value_type="YYYY-MM-DD"
                :confirm="false"
                :clearable="true"
                :disabled_date="['- 24 months', '+ 1 month']"
                :label="translate('tariffication.order_date')"
                :placeholder="translate('tariffication.order_date')"
                :disabled="!read_only"
            />
          </div>
          <div class="col-md-3" >
            <fg-input
                v-model="tariffed_device_info.order"
                type="text"
                :label="translate('tariffication.order')"
                :placeholder="translate('tariffication.order')"
                :readonly="true"
            />
          </div>
        </div>

        <div class="row">
          <div class="col-md-3">
            <WrapDatePicker
                v-model="tariffed_device_info.date_start"
                type="date"
                :range="false"
                value_type="YYYY-MM-DD"
                :confirm="false"
                :clearable="true"
                :disabled="!read_only"
                :disabled_date="['- 12 months', '+ 1 month']"
                :label="translate('tariffication.date_start')"
                :placeholder="translate('tariffication.date_start')"
            />
          </div>
          <div class="col-md-3">
            <WrapDatePicker
                v-model="tariffed_device_info.date_end"
                type="date"
                :range="false"
                value_type="YYYY-MM-DD"
                :confirm="false"
                :clearable="true"
                :disabled="true"
                :disabled_date="[date_closed, '+ 2 month']"
                :label="translate('tariffication.date_end')"
                :placeholder="translate('tariffication.date_end')"
            />
          </div>
          <div class="col-md-3">
            <fg-input
                :value="tariff_days"
                type="text"
                :label="translate('tariffication.days_current_total')"
                :readonly="true"
            />
          </div>
          <div class="col-md-3">
            <fg-input
                v-model="tariffed_device_info.client_inn"
                type="text"
                :label="translate('tariffication.client_inn')"
                :placeholder="translate('tariffication.client_inn')"
            />
          </div>
        </div>

        <div class="row">
          <div class="col-md-6">
            <router-link :to="'/device/' + tariffed_device_info.fid" class="link">
              <fg-input v-model="device_name" type="text" :label="translate('tariffication.device')"
                        :placeholder="translate('tariffication.device')" :readonly="true"/>
            </router-link>
          </div>
          <div class="col-md-3">
              <fg-input
                  v-model="username_start_end"
                  type="text"
                  :label="translate('tariffication.username')"
                  :placeholder="translate('tariffication.username')"
                  :readonly="true"
              />
          </div>
          <div class="col-md-3" v-if="tariffed_device_info.ts_tariff_end > 0">
            <fg-input
                v-model="get_ts_tariff_end"
                type="text"
                :label="translate('tariffication.ts_tariff_end')"
                :placeholder="translate('tariffication.ts_tariff_end')"
                :readonly="true"
            />
          </div>
        </div>

        <div class="row">
          <div class="col-md-6">
            <fg-input
                :value="tariffed_device_info.awaiting_deactivation ? translate('yes') : translate('no')"
                :label="translate('tariffed_device.awaiting_deactivation')"
                :readonly="true"
            />
          </div>
          <div class="col-md-6">
            <fg-input
                :value="tariffed_device_info.device_released_at ? get_date(tariffed_device_info.device_released_at) : ''"
                :label="translate('tariffed_device.device_released_at')"
                :readonly="true"
            />
          </div>
        </div>

        <div class="row">
          <div class="col-md-5">
            <fg-input
                v-model="tariffed_device_info.device_name"
                type="text"
                :label="translate('tariffication.device_name_in_tariff')"
                :placeholder="translate('tariffication.device_name_in_tariff')"
                :readonly="!$store.getters.getPermissions.permissionCommerceGod"
            />
          </div>
          <div class="col-md-7">
            <fg-input
                v-model="tariffed_device_info.device_address"
                type="text"
                :label="translate('tariffication.device_address_in_tariff')"
                :placeholder="translate('tariffication.device_address_in_tariff')"
                :readonly="!$store.getters.getPermissions.permissionCommerceGod"
            />
          </div>
        </div>

        <div class="row">
          <div class="col-md-12">
            <div class="form-group">
              <label>{{ translate("tariffication.comment") }}</label>
              <textarea
                  v-model="tariffed_device_info.comment"
                  :rows="comment_rows"
                  class="form-control border-input"
                  :placeholder="translate('tariffication.comment')"
              />
            </div>
          </div>
        </div>

        <div class="row" v-if="tariffed_device_info.status === 0">
          <div class="col-md-3"></div>
          <div class="col-md-3"></div>
          <div class="col-md-3">
            <label> {{ translate('tariffed_device.modal_complete_tariffication.create_deactivation_request_at_expiration') }} </label>
            <tree-select
                v-model="tariffed_device_info.create_deactivation_request_at_expiration"
                :options="complete_tariffed_list"
                :placeholder="translate('tariffed_device.modal_complete_tariffication.create_deactivation_request_at_expiration')"
                :disabled="true"
            />
          </div>
          <div class="col-md-3">
            <label> {{ translate('tariffed_device.modal_complete_tariffication.block_device_at_expiration') }} </label>
            <tree-select
                v-model="tariffed_device_info.block_device_at_expiration"
                :options="complete_tariffed_list"
                :placeholder="translate('tariffed_device.modal_complete_tariffication.block_device_at_expiration')"
                :disabled="true"
            />
          </div>
        </div>

        <div class="buttons">
          <router-link :to="'/tariffication/tariffed_devices?&fid=' + tariffed_device_info.fid" class="btn btn-success btn-fill btn-wd">
            {{ translate("tariffication.device_tarif_history") }}
          </router-link>
          <span v-if="has_changes && permission_commerce_god" class="btn btn-success btn-fill btn-wd" @click.prevent="change_tariff">
            {{ translate("save") }}
          </span>
          <span
              v-if="tariffed_device_info.status === 1 && !tariffed_device_info.awaiting_deactivation && permission_commerce_god"
              class="btn btn-info btn-fill btn-wd"
              @click.prevent="await_deactivation"
          >
            {{ translate('tariffed_device.await_deactivation') }}
          </span>
          <span v-if="!tariffed_device_info.date_end && permission_commerce_god" class="btn btn-warning btn-fill btn-wd" @click.prevent="complete_tariffing">
            {{ translate("tariffed_device.complete_tariffing") }}
          </span>
        </div>
      </div>

      <div class="response_table" v-if="tariffed_device_info.simcards.length > 0">
        <label>{{ translate('services.blocked_simcard.adding_blocked_simcards') }}</label>
        <table>
          <thead style="height: 50px; flex:0; display: inline-block">
          <tr>
            <th scope="col">
              {{ translate('services.blocked_simcard.simcard_profile_status') }}
            </th>
            <th scope="col">
              {{ translate('services.blocked_simcard.mno') }}
            </th>
            <th scope="col">
              {{ translate('services.blocked_simcard.msisdn') }}
            </th>
            <th scope="col">
              {{ translate('services.blocked_simcard.imsi') }}
            </th>
            <th scope="col">
              {{ translate('services.blocked_simcard.iccid') }}
            </th>
            <th scope="col">
              {{ translate('services.blocked_simcard.actions') }}
            </th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="(simcard, key) in tariffed_device_info.simcards" :key="key" class="status_item">
            <td :data-label="translate('services.blocked_simcard.simcard_profile_status')">
                <span class="badge" :class="global_status_color(+simcard.status)">
                    {{ translate(global_status_text(+simcard.status)) }}
                </span>
            </td>
            <td :data-label="translate('services.blocked_simcard.mno')" @click.stop="" class="mno">
              <a v-if="simcard.mno_link" :href="simcard.mno_link">
                {{ simcard.mno }}
              </a>
              <p v-else>
                {{ simcard.mno }}
              </p>
            </td>
            <td :data-label="translate('services.blocked_simcard.msisdn')">
              {{ simcard.msisdn }}
            </td>
            <td :data-label="translate('services.blocked_simcard.imsi')">
              {{ simcard.imsi }}
            </td>
            <td :data-label="translate('services.blocked_simcard.iccid')">
              {{ simcard.iccid }}
            </td>
            <td :data-label="translate('services.blocked_simcard.actions')" class="actions">
              <p v-if="tariffed_device_info.date_end === null">
                <span
                  v-if="simcard.can_block"
                  class="action btn btn-success"
                  @click="add_blocked_simcard(simcard)"
              >
                +
              </span>
                <span
                    v-if="simcard.tariffication_blocked_simcard_id"
                    class="mdi mdi-eye action btn btn-info"
                    @click="get_blocked_simcard_info(simcard.tariffication_blocked_simcard_id)"
                />
              </p>
            </td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>

    <div class="tariffed_device_info__right">
      <Summary type="tariffed_device" :info="tariffed_device_info" :view_history="false" />
    </div>
  </div>

</template>
<script>
import Summary from "components/UIComponents/Summary/Summary.vue";
import WrapDatePicker from "components/UIComponents/WrapDatePicker/WrapDatePicker.vue";
import SisIconStatus from "components/UIComponents/Icon/SisIconStatus.vue";
import AddBlockedSimCard from "./Modal/AddBlockedSimCard.vue";
import ShowBlockedSimCard from "@/views/Dashboard/General/Services/Tabs/BlockedSimcard/Modal/ShowBlockedSimCard.vue";
import CompleteTariffing from "./Modal/CompleteTariffing.vue";

const fields_to_check = [
  "client_service_id",
  "date_start",
  "date_end",
  "order_id",
  "order_date",
  "comment",
  "client_inn",
  "device_name",
  "device_address"
];

export default {
  name: 'TariffedDeviceInfo',
  components: {
    WrapDatePicker,
    SisIconStatus,
    Summary
  },

  props: {
    tariffed_device: {
      type: Object,
      required: true
    }
  },

  data() {
    return {
      tariffed_device_info: {},
    }
  },

  created() {
    this.tariffed_device_info = JSON.parse(JSON.stringify(this.tariffed_device))
  },

  activated() {
    this.tariffed_device_info = JSON.parse(JSON.stringify(this.tariffed_device))
  },
  computed: {
    date_order_started(){
      let date = null
      if (this.tariffed_device_info.date_start){
        date = this.getDateYYYMMDD((new Date(this.tariffed_device_info.date_start)).setDate(new Date(this.tariffed_device_info.date_start).getDate() - 1) / 1000)
      } else {
        date = "- 2 months"
      }
      return date
    },
    complete_tariffed_list(){
      return [
        { id: 0, label: "Нет" },
        { id: 1, label: "Да" }
      ]
    },
    permission_commerce_god(){
      return this.$store.getters.getPermissions.permissionCommerceGod === true
    },
    read_only(){
      return !Boolean(this.tariffed_device_info.date_end) && this.permission_commerce_god
    },
    tariff_days(){
      return `${this.tariffed_device_info.tariff_days_current_month ?? ''} / ${this.tariffed_device_info.tariff_days_total ?? ''}`
    },
    comment_rows(){
      return this.tariffed_device_info.comment ? 4 : 2
    },
    username_start_end(){
      return `${this.tariffed_device_info.username_start} / ${this.tariffed_device_info.username_end}`
    },
    date_closed(){
      let date = null
      if (this.tariffed_device_info.date_end){
        date = this.getDateYYYMMDD((new Date(this.tariffed_device_info.date_end)).setMonth(new Date(this.tariffed_device_info.date_end).getMonth() - 1) / 1000)
      } else {
        date = "- 2 months"
      }
      return date
    },
    tariffed_device_status(){
      return this.tariffed_device_info.status === 1 ? this.translate('tariffication.billed') : this.translate('tariffication.not_billed')
    },
    get_ts_tariff_end(){
      return this.tariffed_device_info.ts_tariff_end !== 0 ? this.get_date(this.tariffed_device_info.ts_tariff_end) : ''
    },
    get_ts_tariff_start(){
      return this.tariffed_device_info.ts_tariff_start !== 0 ? this.get_date(this.tariffed_device_info.ts_tariff_start) : ''
    },
    device_name(){
      return this.tariffed_device_info.fid + " / " + this.tariffed_device_info.device_name
    },

    has_changes() {
      let tariffed_device = fields_to_check.reduce((obj, key) => {
        obj[key] = this.tariffed_device[key];
        return obj;
      }, {});

      let tariffed_device_info = fields_to_check.reduce((obj, key) => {
        obj[key] = this.tariffed_device_info[key];
        return obj;
      }, {});

      return JSON.stringify(tariffed_device) !== JSON.stringify(tariffed_device_info);
    }
  },

  watch: {
    tariffed_device(){
      this.tariffed_device_info = JSON.parse(JSON.stringify(this.tariffed_device))
    }
  },

  methods: {
    await_deactivation(){
      this.$http.v1.awaitDeviceDeactivation(this.tariffed_device_info.id, () => {
        this.$emit('update')
      })
    },
    complete_tariffing(){
      let t = this.$createElement(CompleteTariffing, {
        props: {
          can_create_request_deactivation: this.tariffed_device_info.can_create_request_deactivation,
          id: this.tariffed_device_info.id,
          date_order_started: this.date_order_started
        },
        on: {
          update: () => {
            this.$modal.hide('show_complete_tariffing')
            this.$emit('update')
          },
          close: () => {
            this.$modal.hide('show_complete_tariffing')
          },
        }
      })
      let temp = {
        render() {
          return t
        }
      }
      this.$modal.show(temp, {}, {
        height: 'auto',
        adaptive: true,
        clickToClose: true,
        scrollable: true,
        name: 'show_complete_tariffing'
      })
    },
    get_blocked_simcard_info(blocked_sim_id){
      this.$http.v1.getTarifficationBlockedSimcardInfo(blocked_sim_id, (response) => {
        this.show_blocked_simcard(response.data)
      })
    },
    show_blocked_simcard(blocked_simcard) {
      let t = this.$createElement(ShowBlockedSimCard, {
        props: {
          blocked_simcard_info: blocked_simcard
        },
        on: {
          update: () => {
            this.$modal.hide('show_blocked_simcard')
            this.get_blocked_simcard_devices()
          },
          close: () => {
            this.$modal.hide('show_blocked_simcard')
          },
        }
      })
      let temp = {
        render() {
          return t
        }
      }
      this.$modal.show(temp, {}, {
        height: 'auto',
        width: 800,
        adaptive: true,
        clickToClose: true,
        scrollable: true,
        name: 'show_blocked_simcard'
      })
    },
    add_blocked_simcard(simcard_info) {
      let t = this.$createElement(AddBlockedSimCard, {
        props: {
          simcard_info,
          device_name: this.device_name,
          tariffed_device_info_id: this.tariffed_device_info.id
        },
        on: {
          update: () => {
            this.$modal.hide('add_blocked_simcard')
            this.$emit('update')
          },
          close: () => {
            this.$modal.hide('add_blocked_simcard')
          },
        }
      })
      let temp = {
        render() {
          return t
        }
      }
      this.$modal.show(temp, {}, {
        height: 'auto',
        adaptive: true,
        clickToClose: true,
        scrollable: true,
        name: 'add_blocked_simcard'
      })
    },
    change_tariff() {
      let params = fields_to_check.reduce((obj, key) => {
        obj[key] = this.tariffed_device_info[key];
        return obj;
      }, {});

      this.$http.v1.updateDeviceTariff(this.tariffed_device_info.id, params, () => {
        this.global_notify('info', this.translate('tariffication.tariff_updated'))
        this.$emit('update')
      })

    },
  }
}

</script>

<style lang='scss' scoped>
.tariffed_device_info {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  overflow: auto;

  @media (max-width: 991px) {
    flex-direction: column;
  }

  &__left {
    width: 70%;
    height: 100%;
    margin-right: 10px;
    @media (max-width: 991px) {
      width: 100%;
      height: auto;
    }

    &__wrap {
      padding: 0 10px;
    }

    .form_select{
      .form-control {
        width: 100%;
      }
    }

    .content{
      .buttons{
        display: flex;
        justify-content: space-between;
        flex-wrap: wrap;
        gap: 10px;
      }
      .row{
        display: flex;
        align-items: flex-end;
      }
      .filter{
        min-width: auto;
      }
      .wrap_datepicker{
        margin-bottom: 10px;
      }
      .vue-treeselect{
        margin-bottom: 10px;
      }
    }

    .main_info{
      .form-group{
        position: relative;
      }
      span.edit{
        position: absolute;
        right: 23px;
        bottom: 28px;
        font-size: 16px;
        cursor: pointer;
        &:hover{
          color: #41b883;
        }
      }
    }

    .response_table {
      height: auto;
      padding: 10px 0 0;
      .header{
        display: flex;
        justify-content: space-between;
        align-items: center;
      }
      table{
        .mno{
          a,p{
            margin: 0;
            font-size: 12px;
          }
        }
        .actions{
          display: flex;
          justify-content: center;
          align-items: center;
          gap: 5px;
          p{
            margin-bottom: 0;
          }
          .action{
            padding: 0 7px;
            max-height: 24px;
          }
        }
      }
    }

    .buttons {
      margin-top: 10px;
      .btn{
        margin-right: 10px;
        &:last-child{
          margin-right: 0;
        }
      }
    }
  }

  &__right {
    width: 30%;
    height: 100%;
    @media (max-width: 991px) {
      width: 100%;
      height: auto;
    }
  }
}
</style>
